// Migrated 1:1 from @nexato/nx-core-module (lib/components/user-name.component.ts), #672.
import { Component, input, computed, ChangeDetectionStrategy } from '@angular/core';
import { User } from '../../entities/user/user';

@Component({
  selector: 'app-user-name',
  template: `<span [pTooltip]="apiTooltip()" tooltipPosition="top">{{ displayName() }}</span>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserNameComponent {
  readonly user = input<User | null | undefined>();

  protected readonly isApiUser = computed(() => this.user()?.firstName?.includes('API') ?? false);

  readonly displayName = computed(() => {
    const u = this.user();
    if (u?.firstName?.includes('API')) {
      return u.firstName;
    }
    return `${u?.firstName ?? ''} ${u?.lastName ?? ''}`.trim();
  });

  protected readonly apiTooltip = computed(() => {
    if (!this.isApiUser()) return undefined;
    const lastName = this.user()?.lastName;
    return lastName ? `Key-ID: ${lastName}` : undefined;
  });
}
